<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Date"><br>
                                    <a-range-picker v-model="inputDate" @change="getResNos" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row" v-if="site_type == 'ho'">
                            <div class="col-md-4">
                                <base-input label="Location">
                                    <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Site">
                                    <a-select mode="multiple" v-model="inputSite" @change="getResNos" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Terminal">
                                    <a-select mode="multiple" v-model="inputTerminal" @change="getResNos" showSearch placeholder="All Terminals" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Reservation Number">
                                    <a-select mode="multiple" v-model="inputReservationNo" showSearch placeholder="All Reservation Number" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in reservationNoOptions" :key="option.id" :value="option.id">{{option.order_no}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Group By">
                                    <a-select v-model="inputGroupBy" @change="getResNos" showSearch optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in groupOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" csv-title="Reservation_Report">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <download-excel v-if="JsonData.length > 0" :data="JsonData" name="Reservation_Report.xls" class="float-right"  style=" width: 20%;">
                                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                                </download-excel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
                <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                    <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
                </a-drawer>
            </div>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import reportUtils from '../../components/reportUtils'
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
        import VueJsonToCsv from 'vue-json-to-csv';
        import {
            mapState,
            mapActions
        } from 'vuex'
    
        var component_x;
    
        export default {
            data() {
                return {
                    spinning: false,
                    inputDate: [moment().startOf('day'), moment().endOf('day')],
                    inputGroupBy: 'document_date',
                    groupOptions: [
                        {key: 'document_date', value: 'Business Date'},
                        {key: 'site_id', value: 'Site'},
                        {key: 'terminal_id', value: 'Terminal'},
                        {key: 'customer_name', value: 'Customer Name'}
                    ],
                    inputSite: [],
                    inputTerminal: [],
                    inputReservationNo: [],
                    site_type: "ho",
                    siteOptions: [],
                    terminalOptions: [],
                    reservationNoOptions: [],
                    reservationNos: [],
                    birSalesReports: [],
                    inputLocation: [],
                    locationOptions: [],
                    toggleAdvanceFilter: false,
                    toggleLabel: "Advanced Filter",
                    advancedFilterParams: {},
                    params: {},
                    advancedFilterVisible: true,
    
                    showSortInfo: 'asc',
                    JsonData: [],
                    inputBrand: null,
                    brandOptions: [],
                    subBrandOptions: [],
                    inputSubBrands: [],
                }
            },
            mounted: async function () {
                component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);
    
                //Get all locations
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
    
                //Start get valid Terminals
                var terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + secureStorage.getItem("defaultSiteId"), null);
                component_x.terminalOptions = terminals;
                component_x.sort(component_x.terminalOptions);
                //End get valid Terminals
    
                //Get Reservations Based on default Site
                let from_header = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss')
                let to_header = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss')
                var res_nos = await HTTPRequest.getRequest(component_x.endPoint + "basic_sales_reports/get_reservation_nos?site_id=" + secureStorage.getItem("defaultSiteId") + "&from_header=" + from_header + "&to_header=" + to_header + "&terminal_id=" + this.inputTerminal + "&group_by=" + this.inputGroupBy, null);
                if(res_nos.length > 0){
                    component_x.reservationNoOptions = res_nos[0].report_details;
                    component_x.reservationNos = res_nos;
                }
                //component_x.sort(component_x.reservationNoOptions);
                //End Reservations Based on default Site
    
                let siteId = secureStorage.getItem("defaultSiteId")
                this.inputSite = [siteId]
    
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
            },
            computed: {
                ...mapState(['endPoint', 'categoriesOptions']),
            },
            components:{
                AdvanceFilter,VueJsonToCsv
            },
            watch: {
                isVatBreakdown: function() {
                    if(this.isVatBreakdown == true){
                        this.isPercent = true
                        this.isNetReturn = false
                        this.isDiscount = false
                    }
                }
            },
            methods: {
                ...mapActions(['updateCategoriesOptions']),
                moment,
                async getResNos(){
                    this.spinning= true;
                    //Get Reservations Based on Filter
                    let from_header = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss')
                    let to_header = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss')
                    component_x.reservationNoOptions = []
                    var res_nos = await HTTPRequest.getRequest(component_x.endPoint + "basic_sales_reports/get_reservation_nos?site_id=" + this.inputSite + "&from_header=" + from_header + "&to_header=" + to_header + "&terminal_id=" + this.inputTerminal + "&group_by=" + this.inputGroupBy , null);
                    if(res_nos.length > 0){
                        component_x.reservationNoOptions = res_nos[0].report_details;
                        component_x.reservationNos = res_nos;
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.inputReservationNo = []
                    //End Reservations Based Filter
                    this.spinning= false;
                },
                async onLocationChange(){
                    this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputSite = this.siteOptions.map( s => s.id);
    
                    //Start get valid Terminals
                    var terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + this.inputSite, null);
                    component_x.terminalOptions = terminals;
                    component_x.sort(component_x.terminalOptions);
                    this.inputTerminal = []
                    //End get valid Terminals
    
                    this.getResNos();
                },
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                showFixed(num, fixed) {
                    fixed = fixed || 0;
                    fixed = Math.pow(10, fixed);
                    return Math.floor(num * fixed) / fixed;
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                formatNumber(num) {
                   return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                advanceFilter(value){
                    this.toggleAdvanceFilter = value
                    if(this.toggleAdvanceFilter == true){
                        this.toggleLabel = "Collapse Filter"
                    }else{
                        this.toggleLabel = "Advanced Filter"
                    }
                },
                closeFilter(){
                    this.advanceFilter(false)
                },
                changeParams(params, actualParams, mode){
                    this.params = params
                    this.advamcedFilterParams = actualParams
    
                    if(mode == 'filter'){
                        this.advanceFilter(false);
                    }
                },
                openNotificationWithIcon(type, msg) {
                    if(type == 'error'){
                        this.$notification[type]({
                            message: 'Export Error',
                            description: msg
                        });
                    }else if(type == 'warning'){
                        this.$notification[type]({
                            message: 'No Data Found',
                            description: msg
                        });
                    }
                },
                generateReport: async function () {
                    this.spinning= true;
                    if(this.reservationNos.length == 0){
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                        this.spinning= false;
                        return
                    }
    
                    let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                    let to_header = this.inputDate[1].format('MMMM DD, YYYY')  
                    let reservationNumbers = this.reservationNos;
                
                        let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                        let reportLogo = document.getElementById('reportLogo');
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }
                        let headers = [];
                        headers = [
                                [
                                    {content: '#', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Terminal Name', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Res. No.', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Trans. No.', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Date', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Customer Name', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Down Payment', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Refund of DP', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Amount Due', styles: {halign: 'center', valign: 'center'}},
                                    {content: 'Balance', styles: {halign: 'center', valign: 'center'}}
                                ]
                            ]
    
                        for(let x=0; x < reservationNumbers.length; x++){
                            
                            //If input ResNo is not empty
                            //Map reservationNumbers based on ResNo
                            if(this.inputReservationNo.length > 0){
                                this.birSalesReports = []
                                for(var i = 0; i < reservationNumbers[x].report_details.length; i++) {
                                    if (this.inputReservationNo.includes(reservationNumbers[x].report_details[i].id)) {
                                        this.birSalesReports.push(reservationNumbers[x].report_details[i])
                                    }
                                }
                            } else {
                                this.birSalesReports = reservationNumbers[x].report_details
                            }
    
                            if(x > 0 && this.birSalesReports.length > 0){
                                doc.addPage();
                            }
    
                            let reportData = [];
                            if(this.birSalesReports.length > 0){
                                let sub_total_amount_paid = 0
                                let sub_total_amount_returned = 0
                                let sub_total_amount_due = 0
                                let sub_total_amount_balance = 0
                                let grand_total_amount_paid = 0
                                let grand_total_amount_returned = 0
                                let grand_total_amount_due = 0
                                let grand_total_amount_balance = 0
                                let grouper = 'start'
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    let grouper_name = reportLine.grouper_name
    
                                    if(this.inputGroupBy == 'document_date'){
                                        grouper_name = reportLine.document_date
                                    }
                                    else if(this.inputGroupBy == 'site_id') {
                                        grouper_name = this.siteOptions.find(x => x.id === reportLine.site_id).name
                                    }
                                    else if(this.inputGroupBy == 'terminal_id'){
                                        grouper_name = this.terminalOptions.find(x => x.id === reportLine.terminal_id).name
                                    } else {
                                        grouper_name = reportLine.customer_name
                                    }
                                    
                                    if(grouper == 'start'){
                                        let detail_header = [{content: group_text + ' : ' + grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.grouper_id){
                                            let detail_header = [{content: group_text + ' : ' + grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.grouper_id
                                    let terminal_name = this.terminalOptions.find(x => x.id === reportLine.terminal_id).name
                                    let detail = [
                                        i+1,
                                        terminal_name,
                                        reportLine.order_no,
                                        reportLine.trans_id,
                                        {content: reportLine.document_date, styles: {halign: 'center'}},
                                        {content: reportLine.customer_name, styles: {halign: 'left'}},
                                        this.convertToCurrency(Number(reportLine.amount_paid - reportLine.amount_due)),
                                        this.convertToCurrency(Number(reportLine.amount_returned)),
                                        this.convertToCurrency(Number(reportLine.amount_due)),
                                        this.convertToCurrency(Number((reportLine.amount_due - (reportLine.amount_paid - reportLine.amount_due))))
                                    ]
                                      
                                    sub_total_amount_paid += Number(reportLine.amount_paid - reportLine.amount_due)
                                    sub_total_amount_returned += Number(reportLine.amount_returned)
                                    sub_total_amount_due += Number(reportLine.amount_due)
                                    sub_total_amount_balance += Number(reportLine.amount_due - (reportLine.amount_paid - reportLine.amount_due))
                                    grand_total_amount_paid += Number(reportLine.amount_paid - reportLine.amount_due)
                                    grand_total_amount_returned += Number(reportLine.amount_returned)
                                    grand_total_amount_due += Number(reportLine.amount_due)
                                    grand_total_amount_balance += Number(reportLine.amount_due - (reportLine.amount_paid - reportLine.amount_due))
                                    reportData.push(Object.assign({}, detail))
                        
                                    if(i == this.birSalesReports.length-1){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', '', '', '', '', 'Subtotal :',
                                                this.convertToCurrency(Number(sub_total_amount_paid)),
                                                this.convertToCurrency(Number(sub_total_amount_returned)),
                                                this.convertToCurrency(Number(sub_total_amount_due)),
                                                this.convertToCurrency(Number(sub_total_amount_balance)),
                                            ]));
                    
                                        //Grand Total
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', '', '', '', '', 'Grand Total :',
                                                this.convertToCurrency(Number(grand_total_amount_paid)),
                                                this.convertToCurrency(Number(grand_total_amount_returned)),
                                                this.convertToCurrency(Number(grand_total_amount_due)),
                                                this.convertToCurrency(Number(grand_total_amount_balance))
                                            ]));
                                    } else {
                                        let current_grouper = ""
                                        let next_grouper = ""
    
                                        current_grouper = reportLine.grouper_id
                                        next_grouper = this.birSalesReports[i+1].grouper_id
    
                                        if(current_grouper != next_grouper){
                                            //Subtotal
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, ['', '', '', '', '', 'Subtotal :',
                                                this.convertToCurrency(Number(sub_total_amount_paid)),
                                                this.convertToCurrency(Number(sub_total_amount_returned)),
                                                this.convertToCurrency(Number(sub_total_amount_due)),
                                                this.convertToCurrency(Number(sub_total_amount_balance)),
                                            ]));
    
                                            sub_total_amount_paid = 0
                                            sub_total_amount_returned = 0
                                            sub_total_amount_due = 0
                                            sub_total_amount_balance = 0
                                        }
                                    }
                                        
                                }
                            }
                            let design_x = 340
                            let design_y = 205
                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"Reservation Report By " + group_text)
                            doc.setFontType("normal");
                            doc.setFontSize(10);
        
                                let site_text = ''
                                if(this.inputSite.length == 0){
                                    site_text = 'All Sites'
                                } else {
                                    let sites = this.inputSite
                                    for (var s = 0; s < sites.length; s++) {
                                        if(s == 0){
                                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                        } else {
                                            site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                        }
                                    }
                                }
                                doc.text(340,20,site_text,"right");
                            
                            doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
    
                            let colStyles = {}
                            colStyles = {
                                0: {cellWidth: 10},
                                1: {cellWidth: 40},
                                2: {cellWidth: 40},
                                3: {cellWidth: 25},
                                4: {cellWidth: 30},
                                5: {cellWidth: 75},
                                6: {cellWidth: 30},
                                7: {cellWidth: 30},
                                8: {cellWidth: 25},
                                9: {cellWidth: 25},
                                10: {cellWidth: 25}
                            }
    
                            doc.autoTable({
                                startY: 35,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                styles: {
                                    cellPadding: 1.0, fontSize: 10,
                                    halign: 'right'
                                },
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });
                        
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
    
                            let pageCount = doc.internal.getNumberOfPages();

                            for(let i = 1; i <= pageCount; i++) {
                                doc.setPage(i);
                                reportUtils.pdfTools.addFooter(doc, printed_by, "Reservation Report By " + group_text, design_x, design_y, i, pageCount)
                            }
    
                        }
                        window.open(URL.createObjectURL(doc.output("blob")))
                    
                    this.spinning= false;
                },
                generateFile: async function() {
                    this.spinning= true;
                    if(this.reservationNos.length == 0){
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                        this.spinning= false;
                        return
                    }
    
                    let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                    let to_header = this.inputDate[1].format('MMMM DD, YYYY')
                    
                    if(this.reservationNos.length > 0){
                        let reservationNumbers = this.reservationNos;
                        let headers = ['#','Terminal Name','Reservation No','Trans No','Date','Customer Name','Down Payment','Refund of DP','Amount Due','Balance'];
                        let site_specific = [];
                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }
    
                        for(let x=0; x < reservationNumbers.length; x++){
                            //If input ResNo is not empty
                            //Map reservationNumbers based on ResNo
                            if(this.inputReservationNo.length > 0){
                                this.birSalesReports = []
                                for(var i = 0; i < reservationNumbers[x].report_details.length; i++) {
                                    if (this.inputReservationNo.includes(reservationNumbers[x].report_details[i].id)) {
                                        this.birSalesReports.push(reservationNumbers[x].report_details[i])
                                    }
                                }
                            } else {
                                this.birSalesReports = reservationNumbers[x].report_details
                            }
                        
                            let reportData = [];
                            if(x > 0){
                                // Add second set of headers
                                reportData.push(headers)
                            }
    
                            if(this.birSalesReports.length > 0){
                                let sub_total_amount_paid = 0
                                let sub_total_amount_returned = 0
                                let sub_total_amount_due = 0
                                let sub_total_amount_balance = 0
                                let grand_total_amount_paid = 0
                                let grand_total_amount_returned = 0
                                let grand_total_amount_due = 0
                                let grand_total_amount_balance = 0
                                let grouper = 'start'
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    let grouper_name = reportLine.grouper_name
    
                                    if(this.inputGroupBy == 'document_date'){
                                        grouper_name = reportLine.document_date
                                    }
                                    else if(this.inputGroupBy == 'site_id') {
                                        grouper_name = this.siteOptions.find(x => x.id === reportLine.site_id).name
                                    }
                                    else if(this.inputGroupBy == 'terminal_id'){
                                        grouper_name = this.terminalOptions.find(x => x.id === reportLine.terminal_id).name
                                    } else {
                                        grouper_name = reportLine.customer_name
                                    }
    
                                    if(grouper == 'start'){
                                        let detail_header = [group_text + ' : ' + grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.grouper_id){
                                            let detail_header = [group_text + ' : ' + grouper_name];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.grouper_id
                                    let terminal_name = this.terminalOptions.find(x => x.id === reportLine.terminal_id).name
                                    let detail = [
                                        i+1,
                                        String(terminal_name),
                                        String(reportLine.order_no),
                                        Number(reportLine.trans_id),
                                        reportLine.document_date,
                                        String(reportLine.customer_name),
                                        Number(reportLine.amount_paid - reportLine.amount_due),
                                        Number(reportLine.amount_returned),
                                        Number(reportLine.amount_due),
                                        (Number(reportLine.amount_due) - Number((reportLine.amount_paid - reportLine.amount_due)))
                                    ]
                                    
                                    sub_total_amount_paid += Number(reportLine.amount_paid - reportLine.amount_due)
                                    sub_total_amount_returned += Number(reportLine.amount_returned)
                                    sub_total_amount_due += Number(reportLine.amount_due)
                                    sub_total_amount_balance += Number(reportLine.amount_due - (reportLine.amount_paid - reportLine.amount_due))
                                    grand_total_amount_paid += Number(reportLine.amount_paid - reportLine.amount_due)
                                    grand_total_amount_returned += Number(reportLine.amount_returned)
                                    grand_total_amount_due += Number(reportLine.amount_due)
                                    grand_total_amount_balance += Number(reportLine.amount_due - (reportLine.amount_paid - reportLine.amount_due))
    
                                    reportData.push(Object.assign({}, detail))
    
                                    if(i == this.birSalesReports.length-1){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ['', '', '', '', '', 'Subtotal :',
                                                this.convertToCurrency(Number(sub_total_amount_paid)),
                                                this.convertToCurrency(Number(sub_total_amount_returned)),
                                                this.convertToCurrency(Number(sub_total_amount_due)),
                                                this.convertToCurrency(Number(sub_total_amount_balance))
                                            ]));
                    
                                        //Grand Total
                                        reportData.push(Object.assign({}, ['', '', '', '', '', 'Grand Total :',
                                                this.convertToCurrency(Number(grand_total_amount_paid)),
                                                this.convertToCurrency(Number(grand_total_amount_returned)),
                                                this.convertToCurrency(Number(grand_total_amount_due)),
                                                this.convertToCurrency(Number(grand_total_amount_balance))
                                            ]));
                                    } else {
                                        let current_grouper = ""
                                        let next_grouper = ""
    
                                        current_grouper = reportLine.grouper_id
                                        next_grouper = this.birSalesReports[i+1].grouper_id
    
                                        if(current_grouper != next_grouper){
                                            //Subtotal
                                            reportData.push(Object.assign({}, ['', '', '', '', '', 'Subtotal :',
                                                this.convertToCurrency(Number(sub_total_amount_paid)),
                                                this.convertToCurrency(Number(sub_total_amount_returned)),
                                                this.convertToCurrency(Number(sub_total_amount_due)),
                                                this.convertToCurrency(Number(sub_total_amount_balance))
                                            ]));
    
                                            sub_total_amount_paid = 0
                                            sub_total_amount_returned = 0
                                            sub_total_amount_due = 0
                                            sub_total_amount_balance = 0
                                        }
                                    }
                                }
    
                            }
    
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                            
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
                            reportData.push([])
                            reportData.push(["Reservation Report By " + group_text, "Generated By: " + printed_by,"","","","For the Period of " + from_header + " to " + to_header])
                            reportData.push([])
    
                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                          [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
                        }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.spinning= false;
                },
                clearJsonData(){
                  this.JsonData = [];
                },
            }
        };
    </script>
    
    <style></style>
    